import React, { useState } from 'react';

import { makeStyles, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TableSortLabel, Box, Tooltip } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';

import RoleCell from './RoleCell';
import UserActionsMenu from './UserActionsMenu';
import UserStatusCell from './UserStatusCell';
import { MODALITY_OPTIONS_LABELS } from '../../constants/observations';
import TableEmailCell from '../common/TableEmailCell';

const useStyles = makeStyles(() => ({
  emailCell: {
    width: '300px',
  },
  roleCell: {
    maxWidth: '250px',
    minWidth: '150px',
  },
  table: {
    minWidth: 650,
  },
  tableCell: {
    paddingBottom: '8px !important',
    paddingTop: '8px !important',
  },
  tableContainer: {
    marginTop: '1rem',
    maxHeight: 600,
    maxWidth: '1200px',
    width: '100%',
  },
  tableHeader: {
    borderBottom: '1px solid #EBEBEB',
  },
  tableHeaderCell: {
    '& .MuiTableSortLabel-root': {
      fontSize: 12,
      fontWeight: 'bold',
    },
    backgroundColor: '#FFF',
    borderBottom: '1px solid #EBEBEB',
    fontSize: 12,
    fontWeight: 'bold',
    paddingTop: 0,
  },
}));

const renderModalityCell = (user) => {
  let modality = '-';

  if (user.role === 'technologist' && user.modality) {
    modality = MODALITY_OPTIONS_LABELS[user.modality] || user.modality;
  }

  // Calculate FTE percentage
  const ftePercentage = user.fullTimeEmployment ? Math.round(user.fullTimeEmployment * 100) : 100;
  const tooltipTitle = `FTE: ${ftePercentage}%`;

  return (
    <Tooltip title={tooltipTitle} arrow placement="top">
      <Typography variant="body2" style={{ cursor: 'default' }}>
        {modality}
      </Typography>
    </Tooltip>
  );
};

const UsersTable = ({ onCriteriaChange, users, total, onResendInvitation, onChangeUserStatus, onUpdateUser }) => {
  const classes = useStyles();
  const ROWS_PER_PAGE = 10;
  const [page, setPage] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
    onCriteriaChange({ page: newPage - 1 });
  };

  return (
    <>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} stickyHeader>
          <TableHead className={classes.tableHeader}>
            <TableRow>
              <TableCell className={classes.tableHeaderCell}>Name</TableCell>
              <TableCell className={`${classes.tableHeaderCell} ${classes.emailCell}`}>Email Address</TableCell>
              <TableCell className={`${classes.tableHeaderCell} ${classes.roleCell}`}>Role</TableCell>
              <TableCell className={classes.tableHeaderCell}>Facility</TableCell>
              <TableCell className={classes.tableHeaderCell}>Department</TableCell>
              <TableCell className={classes.tableHeaderCell}>Modality</TableCell>
              <TableCell className={classes.tableHeaderCell}>Status</TableCell>
              <TableCell className={classes.tableHeaderCell} />
            </TableRow>
          </TableHead>

          <TableBody>
            {(users || []).map((user) => (
              <TableRow key={user.id} hover>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">{user.name || '-'}</Typography>
                </TableCell>
                <TableCell className={`${classes.tableCell} ${classes.emailCell}`}>
                  <TableEmailCell value={user.email} />
                </TableCell>
                <TableCell className={`${classes.tableCell} ${classes.roleCell}`}>
                  <RoleCell value={user.role} />
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">{user.facilityName || '-'}</Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <Typography variant="body2">{user.departmentName || '-'}</Typography>
                </TableCell>
                <TableCell className={classes.tableCell}>{renderModalityCell(user)}</TableCell>
                <TableCell className={classes.tableCell}>
                  <UserStatusCell status={user.status} />
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <UserActionsMenu user={user} status={user.status} onResendInvitation={onResendInvitation} onChangeUserStatus={onChangeUserStatus} onUpdateUser={onUpdateUser} />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {total > ROWS_PER_PAGE && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination count={Math.ceil(total / ROWS_PER_PAGE)} page={page + 1} onChange={handleChangePage} color="primary" />
        </Box>
      )}
    </>
  );
};

export default UsersTable;
